export const STATUS_LABELS = {
  draft: "Draft",
  pending_review: "Menunggu Pemeriksaan",
  verified: "Terverifikasi",
  approved: "Disetujui",
  published: "Terbit",
  needs_revision: "Perlu Revisi",
  archived: "Diarsipkan",
};

export const STATUS_COLORS = {
  draft: "bg-gray-100 text-gray-700 border-gray-300",
  pending_review: "bg-blue-100 text-blue-700 border-blue-300",
  verified: "bg-indigo-100 text-indigo-700 border-indigo-300",
  approved: "bg-emerald-100 text-emerald-700 border-emerald-300",
  published: "bg-green-600 text-white border-green-700",
  needs_revision: "bg-amber-100 text-amber-800 border-amber-300",
  archived: "bg-slate-200 text-slate-600 border-slate-300",
};

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  publisher: "Penanggung Jawab Publikasi",
  editor: "Editor/Verifikator Unit",
  operator: "Operator (Input Semua Unit)",
  contributor: "Kontributor",
  pending: "Menunggu Penetapan Peran",
};

export const CONTENT_TYPES = [
  { slug: "berita_kegiatan", name: "Berita Kegiatan" },
  { slug: "edukasi", name: "Edukasi" },
  { slug: "pengumuman", name: "Pengumuman" },
  { slug: "data_informasi", name: "Data & Informasi" },
];

export const PROGRAM_LABELS = ["PAPA BERSERI", "Pilah", "Angkut", "Pengolahan", "Proses Akhir"];

export function StatusBadge({ status }) {
  return (
    <span className={`inline-block text-xs font-bold px-2.5 py-1 rounded-full border ${STATUS_COLORS[status] || "bg-gray-100"}`} data-testid={`status-${status}`}>
      {STATUS_LABELS[status] || status}
    </span>
  );
}
